export const DISPLAY_FEATURES_DEVELOPING = true;

export const isCN = localStorage.getItem('mock_cn_deploy_flag') || window.location.host.includes('zhihuiya.com');
